module.exports = __webpack_public_path__ + "img/gxjn_s.2e93fc2.png";